import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Header from "@/components/Header";
import { toast } from "sonner";

export default function ChangePasswordPage() {
    const { user, changePassword, logout } = useAuth();
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const forced = user && user !== false && user.must_change_password;

    const submit = async (e) => {
        e.preventDefault();
        if (next.length < 6) return toast.error("Password must be at least 6 characters");
        if (next !== confirm) return toast.error("Passwords do not match");
        setSubmitting(true);
        const res = await changePassword(current, next);
        setSubmitting(false);
        if (!res.ok) return toast.error(res.error);
        toast.success("Password updated");
        navigate("/dashboard", { replace: true });
    };

    return (
        <>
            {!forced && <Header />}
            <main className="max-w-md mx-auto px-6 py-16">
                <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-bold mb-2">
                    {forced ? "Set a new password" : "Change password"}
                </h1>
                <p className="text-muted-foreground mb-8">
                    {forced
                        ? "For security, please change your default password before continuing."
                        : "Enter your current password and choose a new one."}
                </p>
                <form
                    onSubmit={submit}
                    className="glass-tile rounded-3xl p-8 space-y-5"
                    data-testid="change-password-form"
                >
                    <div className="space-y-1.5">
                        <Label htmlFor="cp-current">Current password</Label>
                        <Input
                            id="cp-current"
                            type="password"
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                            className="h-11 rounded-xl"
                            data-testid="input-current-password"
                            required
                        />
                    </div>
                    <div className="space-y-1.5">
                        <Label htmlFor="cp-new">New password</Label>
                        <Input
                            id="cp-new"
                            type="password"
                            value={next}
                            onChange={(e) => setNext(e.target.value)}
                            className="h-11 rounded-xl"
                            data-testid="input-new-password"
                            required
                        />
                    </div>
                    <div className="space-y-1.5">
                        <Label htmlFor="cp-confirm">Confirm new password</Label>
                        <Input
                            id="cp-confirm"
                            type="password"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            className="h-11 rounded-xl"
                            data-testid="input-confirm-password"
                            required
                        />
                    </div>
                    <Button type="submit" className="w-full h-11 rounded-xl" disabled={submitting} data-testid="submit-change-password">
                        {submitting ? "Saving..." : "Update password"}
                    </Button>
                    {forced && (
                        <Button
                            type="button"
                            variant="ghost"
                            className="w-full"
                            onClick={logout}
                            data-testid="cancel-change-password"
                        >
                            Sign out
                        </Button>
                    )}
                </form>
            </main>
        </>
    );
}
